import { ChartOptionsProvider } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class MedianChartOptionsProvider extends ChartOptionsProvider {

    public getOptions(medianData, title = 'Medians', xAxesLabel = 'Regions') {
        const chartOptions = {
            chart: {
                type: 'column',
                plotBackgroundColor: '#fdfdfd',
                backgroundColor: '#ffffff'
              },
            title: title,
            legend: title,
            plotOptions: {
                column: {
                    colorByPoint: true
                }
            },
            // colors: [
            //     '#ff0000',
            //     '#00ff00',
            //     '#0000ff'
            // ],
            xAxis: {
                minTickInterval: 1,
                enabled: true,
                labels: {
                    align: 'center',
                    autoRotation: 0
                },
                categories: medianData.map(item => item.name),
                title: {
                    text: title
                }
            },
            yAxis: {
                title: {
                    text: 'Implied/Yr3(e) (%)'
                }
            },
            tooltip: this.defaultChartOptions.tooltip,
            series: [
                {
                    name: xAxesLabel,
                    data: medianData.map(item => item.impliedEbitY3 * 100),
                    visible: true
                }]
        }

       return chartOptions;
    };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/medians.ts